var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Estruturas Organizacionais")]),_c('div',{staticClass:"card"},[_c('Item',{staticClass:"pr-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }